type ReadableArray<T> = ReadonlyArray<T> | T[];

/**
 * Return the last item of the array
 *
 * @deprecated - Import from @deltasierra/utilities-array instead
 * @param arr - The source array
 * @returns The last item of the array or undefined if the array is empty
 */
export function last<T>(arr: ReadableArray<T>): T | undefined {
    return arr[arr.length - 1];
}
